import { useEffect, useState } from "react";
import type { VenueSummary } from "../models/EventModel";

type CacheEntry = {
    venues: VenueSummary[];
    ts: number;
};

let venuesCache: CacheEntry = { venues: [], ts: 0 };

export function useVenues(options?: { maxAgeMs?: number }) {

    const maxAgeMs = options?.maxAgeMs ?? (60000 * 60); // 1h

    const cached = venuesCache;
    const [venues, setVenues] = useState<VenueSummary[]>(cached?.venues ?? []);
    const [loading, setLoading] = useState<boolean>(cached.venues.length === 0);

    useEffect(() => {
        const now = Date.now();
        const cacheHit = venuesCache;
        const fresh = cacheHit.venues.length > 0 && now - cacheHit.ts < maxAgeMs;

        if (fresh) {
            setVenues(cacheHit.venues);
            setLoading(false);
            return;
        }

        fetchVenues();
    }, []);

    const fetchVenues = async () => {
        setLoading(true);
        try {
            const response = await fetch('/api/events/venues');
            if (!response.ok) {
                throw new Error();
            }
            const data = await response.json();
            venuesCache = { venues: data, ts: Date.now() };
            setVenues(data);
        } catch (error) {
            console.error('Error fetching venues:', error);
        } finally {
            setLoading(false);
        }
    };

    return {
        venues,
        loading,
        reload: fetchVenues
    };
}
